function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#TextDocument_svg__clip0_1818_35811)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.375 8.75a.625.625 0 01-.625-.625v-.208H5.417v.208a.625.625 0 01-1.25 0v-.833c0-.345.28-.625.625-.625h4.583c.345 0 .625.28.625.625v.833c0 .345-.28.625-.625.625z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.083 12.5a.625.625 0 01-.625-.625V7.292a.625.625 0 011.25 0v4.583c0 .345-.28.625-.625.625z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.708 12.5h-1.25a.625.625 0 010-1.25h1.25a.625.625 0 010 1.25zM15.208 7.917h-2.917a.625.625 0 010-1.25h2.917a.625.625 0 010 1.25zM15.208 10.208h-2.917a.625.625 0 010-1.25h2.917a.625.625 0 010 1.25zM15.208 12.5h-2.917a.625.625 0 010-1.25h2.917a.625.625 0 010 1.25zM15.208 15H4.792a.625.625 0 010-1.25h10.416a.625.625 0 010 1.25zM15.208 17.5H4.792a.625.625 0 010-1.25h10.416a.625.625 0 010 1.25z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.041 20H3.958a2.294 2.294 0 01-2.292-2.292V2.292A2.294 2.294 0 013.958 0h12.084a2.294 2.294 0 012.291 2.292v15.416A2.294 2.294 0 0116.042 20zM3.958 1.25c-.574 0-1.042.468-1.042 1.042v15.416c0 .575.468 1.042 1.042 1.042h12.084c.574 0 1.041-.468 1.041-1.042V2.292c0-.574-.467-1.042-1.041-1.042H3.957z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "TextDocument_svg__clip0_1818_35811"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})));

function SvgTextDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgTextDocument;